// extracted by mini-css-extract-plugin
export default {"container":"ErrorMessage_container__VgyyL","message":"ErrorMessage_message__iuGrJ","retry":"ErrorMessage_retry__Ogfv2"};